import { Observable } from 'rxjs/Rx'
import { combineEpics } from 'redux-observable'
import { create, freightForwarders, favourite, modify } from 'store/services/favourite'
import * as authenticationDuck from 'store/ducks/authentication'
import { parseFavouritePayload, decorateFavouriteEntity } from 'store/utils/favourite'
import { alertError, alertSuccess } from 'store/ducks/alert'

// Actions
export const MODIFY_FAVOURITE = 'favourite/MODIFY_FAVOURITE'

export const CREATION_REQUEST = 'favourite/CREATION_REQUEST'
export const CREATION_SUCCESS = 'favourite/CREATION_SUCCESS'
export const CREATION_FAILURE = 'favourite/CREATION_FAILURE'

export const MODIFY_REQUEST = 'favourite/MODIFY_REQUEST'
export const MODIFY_SUCCESS = 'favourite/MODIFY_SUCCESS'
export const MODIFY_FAILURE = 'favourite/MODIFY_FAILURE'

export const CREATION_RESET = 'favourite/CREATION_RESET'

export const FETCH_REQUEST = 'favourite/FETCH_REQUEST'
export const FETCH_SUCCESS = 'favourite/FETCH_SUCCESS'
export const FETCH_FAILURE = 'favourite/FETCH_FAILURE'

export const FREIGHT_FORWARDERS_REQUEST = 'favourite/FREIGHT_FORWARDERS_REQUES'
export const FREIGHT_FORWARDERS_SUCCESS = 'favourite/FREIGHT_FORWARDERS_SUCCESS'
export const FREIGHT_FORWARDERS_FAILURE = 'favourite/FREIGHT_FORWARDERS_FAILURE'

// Reducer
const INITIAL_STATE = {
  creation: {
    isEdition: !!window.location.pathname.split('/')[2],
    loading: false,
    created: false,
    entity: {},
    violations: [],
  },
  freightForwarders: {
    list: [],
    loading: false,
  },
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case CREATION_REQUEST:
    case MODIFY_REQUEST:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: true,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case CREATION_SUCCESS:
    case MODIFY_SUCCESS:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: true,
          entity: action.entity,
          violations: [],
        },
      }
    case CREATION_FAILURE:
    case MODIFY_FAILURE:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          entity: {},
          violations: action.violations,
        },
      }
    case CREATION_RESET:
      return {
        ...state,
        creation: {
          ...state.creation,
          isEdition: false,
          loading: false,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case MODIFY_FAVOURITE:
      return {
        ...state,
        creation: {
          ...state.creation,
          isEdition: true,
        },
      }

    case FETCH_REQUEST:
      return {
        ...state,
        creation: {
          ...state.creation,
          isEdition: true,
          loading: true,
          created: false,
          violations: [],
        },
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          entity: action.entity,
          violations: [],
        },
      }

    case FETCH_FAILURE:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case FREIGHT_FORWARDERS_REQUEST:
      return {
        ...state,
        freightForwarders: {
          list: [],
          loading: true,
        },
      }
    case FREIGHT_FORWARDERS_SUCCESS:
      return {
        ...state,
        freightForwarders: {
          list: action.payload,
          loading: false,
        },
      }
    case FREIGHT_FORWARDERS_FAILURE:
      return {
        ...state,
        freightForwarders: {
          list: [],
          loading: false,
        },
      }
    default:
      return state
  }
}

// Actions Creators
export const modifyFavourite = () => ({
  type: MODIFY_FAVOURITE,
})

export const creationRequest = (payload) => ({
  type: CREATION_REQUEST,
  payload: parseFavouritePayload(payload),
})

export const creationSuccess = (entity) => ({
  type: CREATION_SUCCESS,
  entity,
})

export const creationFailure = (violations) => ({
  type: CREATION_FAILURE,
  violations,
})

export const creationReset = () => ({
  type: CREATION_RESET,
})

export const modifyRequest = (payload) => ({
  type: MODIFY_REQUEST,
  payload,
})

export const modifySuccess = (entity) => ({
  type: MODIFY_SUCCESS,
  entity,
})

export const modifyFailure = () => ({
  type: MODIFY_FAILURE,
})

export const fetchRequest = (id) => ({
  type: FETCH_REQUEST,
  id,
})

export const fetchSuccess = (entity) => ({
  type: FETCH_SUCCESS,
  entity,
})

export const fetchFailure = () => ({
  type: FETCH_FAILURE,
})

export const freightForwardersRequest = (value) => ({
  type: FREIGHT_FORWARDERS_REQUEST,
  value,
})

export const freightForwardersSuccess = (payload) => ({
  type: FREIGHT_FORWARDERS_SUCCESS,
  payload,
})

export const freightForwardersFailure = (errors) => ({
  type: FREIGHT_FORWARDERS_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(creationRequestEpic, freightForwardersRequestEpic, fetchRequestEpic, modifyRequestEpic)

export function creationRequestEpic(action$) {
  return action$.ofType(CREATION_REQUEST).mergeMap((action) =>
    Observable.ajax(create({ payload: action.payload }))
      .map((res) => creationSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(creationFailure(errors))
        } catch (e) {
          return Observable.of(creationFailure())
        }
      }),
  )
}

export function freightForwardersRequestEpic(action$) {
  return action$.ofType(FREIGHT_FORWARDERS_REQUEST).mergeMap((action) =>
    Observable.ajax(freightForwarders(action.value))
      .mergeMap((res) => Observable.of(freightForwardersSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(freightForwardersFailure())
      }),
  )
}

export function fetchRequestEpic(action$) {
  return action$.ofType(FETCH_REQUEST).mergeMap((action) =>
    Observable.ajax(favourite({ params: { id: action.id } }))
      .map((res) => fetchSuccess(decorateFavouriteEntity(res.response)))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(fetchFailure())
      }),
  )
}

export function modifyRequestEpic(action$) {
  return action$.ofType(MODIFY_REQUEST).mergeMap((action) =>
    Observable.ajax(
      modify({
        id: action.payload.id,
        payload: parseFavouritePayload(action.payload.body),
      }),
    )
      .mergeMap((res) =>
        Observable.of(
          modifySuccess(decorateFavouriteEntity(res.response)),
          alertSuccess('La course favorite a bien été modifiée'),
        ),
      )
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), modifyFailure())
      }),
  )
}
